import { anonymousApplicantData, anonymousApplicantIds } from './consts';

const getInitData = (request) => {
  const { clientId, clientName, contactType } = request;

  let data = null;

  if (clientId) {
    data = {
      id: clientId,
      name: clientName || 'Без имени',
      contactType,
    };
  } else if (clientName) {
    data = anonymousApplicantData.get(anonymousApplicantIds.unregistered);
  } else {
    data = anonymousApplicantData.get(anonymousApplicantIds.unspecified);
  }

  return {
    ...data,
    amount: 0,
  };
};

export const generateApplicants = (map) => (request) => {
  const { has, ...data } = getInitData(request);
  const entity = map.get(data.id) || data;
  entity.amount += 1;
  map.set(data.id, entity);
};
